export enum CustomSurveyStatus {
  Valid = "valid",
  Used = "used",
}
